var map = {
	"./arrow-bottom-gray.svg": 52,
	"./cart-white.svg": 53,
	"./check-white.svg": 54,
	"./check.svg": 55,
	"./closer.svg": 56,
	"./dec.svg": 57,
	"./filter.svg": 58,
	"./guarantee.svg": 59,
	"./hit.svg": 60,
	"./inc.svg": 61,
	"./new.svg": 62,
	"./prize-green.svg": 63,
	"./prize-yellow.svg": 64,
	"./question.svg": 65,
	"./sale.svg": 66,
	"./search.svg": 67,
	"./season-all.svg": 68,
	"./shield.svg": 69,
	"./snowflake.svg": 70,
	"./spike.svg": 71,
	"./steering-wheel.svg": 72,
	"./sunshine.svg": 73,
	"./switch-tyre.svg": 74,
	"./switch-wheel.svg": 75,
	"./unchecked.svg": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;